module.exports = __webpack_public_path__ + "static/media/rectangle-portrait.caa77ea7.svg";